import React, { use, useEffect, useRef, useState } from 'react'
import { Alert, Card, CardBody, CardText, CardTitle, Col, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, Row, TabContent, TabPane, Tooltip } from 'reactstrap'
import modelImage from '../../assets/images/users/avatar-7.jpg'
import { useDispatch } from 'react-redux';
import { getDetailData, getsnapshotData, getCameraActive, setMacAddress, getLiveCameraData, getTableData } from 'store/actions';
import { useSelector } from 'react-redux';
import images from 'assets/images/images.png';
import toastr from "toastr";
import Bus_Detail_Form from './Bus_Detail_form';
import Rtsp from './rtsp';
import classnames from "classnames";
import "../../assets/scss/theme.scss";
import Camera_Details_Status from './Camera_Details_Status';
import moment from 'moment';
import ReactApexChart from 'react-apexcharts';
import Cam_Detail_Form from './Add_Modify_cam_detail';

function CombinedDetailsCard({ details }) {

    const dispatch = useDispatch();
    const user = useSelector(state => state.Login.user)
    const sid = user.sessionID;
    const macAddress = useSelector(state => state.Active_Store?.macAddress);
    const files = useSelector(state => state.Data_Table.files);
    const dates = useSelector(state => state.Active_Store?.dates);
    const startDate = dates?.startDate;
    const endDate = dates?.endDate;
    const routeName = useSelector(state => state.Route_List?.activeRoute);
    const regex = new RegExp("[()]", "g");
    let route = routeName.replace(regex, "").trim().split(" ")[0];
    const group = useSelector(state => state.Active_Store?.sub_group)
    const [img_src, setImage] = useState(images);
    const activeCamera = useSelector(state => state.Active_Store?.activeCamera);
    const [modal, setModal] = useState(false);
    const [isLiveStreamOpen, setIsLiveStreamOpen] = useState(false);
    const liveCameras = useSelector(state => state.Live_Camera_Data?.data);
    const [liveStatus, setliveStatus] = useState(false);
    const Bus_Nameplate = details?.RouteDetail.Plate;
    const [rtsp, setRtsp] = useState();
    const permission = (useSelector(state => state.Login?.userData?.data?.roleType?.[0]?.permission));
    const [role, setRole] = useState([]);

    // Camera Details states
    const cameraList = details?.RouteDetail?.Cam_Details;
    const liveCameraData = useSelector(state => state.Live_Camera_Data?.data);
    const activeCamera1 = useSelector(state => state.Active_Store?.activeCamera);
    const ref1 = useRef(null);
    const [snr, setSNR] = useState("");
    const [tx_rate, setTx_rate] = useState("");
    const [s_strength, setS_strength] = useState("");
    const [files_rem, setFileRem] = useState("");
    const [duration, setDuration] = useState("");
    const files_remaining = Math.round(files_rem * 100) / 100;
    const [customActiveTab, setcustomActiveTab] = useState(activeCamera);

    const [speed, setSpeed] = useState("");

    // Recording Status states
    const [chartsData, setChartData] = useState([]);
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        if (permission !== null) {
            setRole(permission.split(",").map(Number));
        }
    }, [])

    toastr.options = {
        positionClass: "toast-top-center",
        progressBar: "progressBar",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "slideDown",
        hideMethod: "slideUp",
        timeOut: 2000,
    };

    const takeSnapshot = () => {
        toastr.success("Request sent")
        if (macAddress) {
            let queryParam = {
                sid: sid,
                id: files?.length > 0 ? liveStatus ? 1 : 2 : 0,
                mac: macAddress,
                filename: files?.length > 0 ? files.toString() : "",
            }
            dispatch(getsnapshotData(queryParam, (response) => {
                if (response?.OK) {
                    if (response.OK.data === null) {
                        toastr.warning("Null Response")
                    }
                    else {
                        toastr.success(response.OK.data)
                    }
                }
                if (response?.error) {
                    toastr.error(response.error.msg);
                }
            }));

            setTimeout(() => {
                console.log("5 sec ");
                let queryParams = {
                    sid: sid,
                    date: startDate,
                    enddate: endDate,
                    route: route,
                    higroup: group,
                }
                dispatch(getDetailData(queryParams));
            }, 5000);
        }
    }

    const setColor = (status) => {
        if (status == 'A')
            return "#FFBF00"
        if (status == 'Y')
            return "#FFFF00"
        if (status == 'R')
            return "#FF0000"
        if (status == 'G')
            return "#00FF00"
    }

    const resetImage = (e) => {
        e.target.src = images;
    }

    useEffect(() => {
        details?.RouteDetail?.Cam_Details?.map((item) => {
            if (activeCamera === item?.Cam) {
                setImage(item?.buspic);
                let rtspurl = (item?.rtsp).split(":");
                setRtsp(rtspurl.slice(0, 3).join(":") + `:${item?.rtspport}` + ((item?.rtsp).split(":")).slice(3).join(":"));
            }
        })
    }, [activeCamera, details]);

    const openModel = () => {
        setModal(true);
    }

    const livestream = () => {
        console.log("livestream");
        setIsLiveStreamOpen(!isLiveStreamOpen);
        console.log(rtsp);
    };

    const [isshowDetailOpen, setIsShowDetailOpen] = useState(false);
    const showDetail = () => {
        setIsShowDetailOpen(!isshowDetailOpen);
    }

    useEffect(() => {
        if (liveCameras) {
            let liveRoute = liveCameras?.data?.filter(item => item.live.bus === activeCamera);
            if (liveRoute?.length > 0) {
                setliveStatus(true);
            } else {
                setliveStatus(false);
            }
        } else {
            setliveStatus(false);
        }
    }, [liveCameras, details, activeCamera])

    // Camera Details Logic
    useEffect(() => {

        if (ref1.current) {
            clearInterval(ref1.current)
        }
        ref1.current = setInterval(async () => {
            console.log("Interval Calls Live DL Status", ref1.current);
            if (macAddress) {
                let queryParams = {
                    sid: sid,
                    mac: macAddress,
                }
                dispatch(getLiveCameraData(queryParams));
            }
        }, 30000);
        return () => {
            if (ref1.current) {
                clearInterval(ref1.current)
            }
        }
    }, [macAddress, activeCamera1]);

    const getActiceCameraDetails = (activeCameraTab) => {
        if (cameraList) {
            const cameraDetails = cameraList.find((item) => item.Cam === activeCameraTab);
            console.log(cameraDetails);
            if (cameraDetails) {
                return cameraDetails;
            }
        }
    }

    const toggleCustom = tab => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    useEffect(() => {
        console.log("Active Camera TAAB", customActiveTab);
        const camera = getActiceCameraDetails(customActiveTab);
        let activeCamera = camera?.Cam;
        let macAddress = camera?.mac;
        let liveStatus = camera?.live === 1 ? true : false;
        dispatch(getCameraActive({ activeCamera, macAddress, liveStatus }));
        let queryParams = {
            sid: sid,
            mac: macAddress,
        }
        dispatch(getLiveCameraData(queryParams));
        setLiveData(liveCameraData);

    }, [customActiveTab]);

    useEffect(() => {
        setcustomActiveTab(activeCamera1);
    }, [activeCamera1])

    useEffect(() => {
        setLiveData(liveCameraData);
    }, [liveCameraData]);

    const setLiveData = (storeLiveData) => {
        cameraList?.map((val) => {
            let liveData = storeLiveData?.data?.filter(item => item.live.bus === val.Cam);
            if (liveData?.length > 0) {
                val.flicker = true;
            } else {
                val.flicker = false;
            }
        })
    }


    const snrBarSeries = [
        {
            data: [-100],
        },
    ];

    const buildSnrBarOptions = (snrValue) => {
        const baseOptions = {
            chart: {
                type: 'bar',
                height: 10,
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    endingShape: 'flat',
                },
            },
            colors: [' #ffd700'],
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    type: 'horizontal',
                    shadeIntensity: 0.25,
                    gradientToColors: ['red', 'yellow', 'green'],
                    inverseColors: true,
                    opacityFrom: 1,
                    opacityTo: 1,
                    colorStops: [
                        {
                            offset: 20,
                            color: 'red'
                        },
                        {
                            offset: 50,
                            color: 'yellow'
                        },
                        {
                            offset: 80,
                            color: 'green'
                        }
                    ]
                },
            },
            xaxis: {
                categories: [''],
                min: -100,
                max: 0,
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                show: false,
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                enabled: false,
            },
        };

        // Only add SNR annotation when camera is live (snrValue is truthy)
        if (snrValue) {
            baseOptions.annotations = {
                xaxis: [
                    {
                        x: parseFloat(snrValue),
                        borderColor: '#FF4500',
                        borderWidth: 2,
                        label: {
                            text: `Signal: ${snrValue}`,
                            position: 'top',
                            orientation: 'horizontal',
                            offsetY: -4,
                            style: {
                                color: '#fff',
                                background: '#FF4500',
                                fontSize: '10px',
                                fontWeight: 600,
                                padding: {
                                    left: 4,
                                    right: 4,
                                    top: 2,
                                    bottom: 2,
                                },
                            },
                        },
                    },
                ],
            };
        }

        return baseOptions;
    };

    const [isshowCamDetailOpen, setIsShowCamDetailOpen] = useState(false);
    const [caminfo, setCamInfo] = useState("");
    const showCamDetail = () => {
        setIsShowCamDetailOpen(!isshowCamDetailOpen);
        if (cameraList) {
            cameraList.map((item) => {
                if (activeCamera1 === item.Cam) {
                    setCamInfo(item);
                    console.log(caminfo);
                }
            })
        }
    }

    // Recording Status Logic
    const getDataWithDates = (startDate, endDate, rGraph) => {
        let dateArray = [];
        let data = [];
        let currentDate = moment(startDate);
        const formattedEndDate = moment(endDate);

        while (currentDate.isSameOrBefore(formattedEndDate, 'day')) {
            dateArray.push(currentDate.format('YYYY-MM-DD'));
            let df = rGraph.find(val => currentDate.isSame(val.date));
            if (df) {
                data.push(parseInt(df.dfiles));
            } else {
                data.push(0);
            }

            currentDate = currentDate.add(1, 'days');
        }

        return { data, dateArray };
    }

    const recordingOptions = {
        chart: { sparkline: { enabled: !0 } },
        stroke: { curve: "smooth", width: 2 },
        colors: ["#3B71CA"],
        fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 10,
                inverseColors: false,
                opacityFrom: 0.7,
                opacityTo: 0.05,
                stops: [25, 100, 100, 100],
            },
        },
        tooltip: {
            enabled: true,
            enabledOnSeries: undefined,
            shared: true,
            followCursor: false,
            intersect: false,
            inverseOrder: false,
            custom: undefined,
            hideEmptySeries: true,
            fillSeriesColor: false,
            theme: false,
            style: {
                fontSize: '12px',
                fontFamily: undefined
            },
            onDatasetHover: {
                highlightDataSeries: false,
            },
            x: {
                show: true,
                format: 'dd MMM',
                formatter: undefined,
            },
            y: {
                formatter: undefined,
                title: {
                    formatter: (seriesName) => seriesName,
                },
            },
            z: {
                formatter: undefined,
                title: 'Size: '
            },
            marker: {
                show: false,
            },
            items: {
                display: "flex",
            },
            fixed: {
                enabled: false,
                position: 'topRight',
                offsetX: 0,
                offsetY: 0,
            },
        }
    }

    const getChartDataForAll = (details, options, storeLiveData) => {
        let data = [];
        let cameraList = details?.RouteDetail?.Cam_Details;
        for (let index = 0; index < cameraList?.length; index++) {
            let chartOptions = { ...options };
            let chart = {};
            const element = cameraList[index];
            let name = element.Cam;
            let series = [];
            let xaxisData = [];
            let dataWithDate = {
                dateArray: [],
                data: []
            };

            if (element.RGraph.length > 0) {
                dataWithDate = getDataWithDates(startDate, endDate, element.RGraph);
            }

            chartOptions['xaxis'] = {
                type: "datetime",
                categories: dataWithDate.dateArray,
                labels: {
                    show: true,
                    format: "dd MMM"
                }
            }

            const today = moment().startOf('day').valueOf();
            const startVal = moment(startDate).startOf('day').valueOf();
            const endVal = moment(endDate).startOf('day').valueOf();

            if (today >= startVal && today <= endVal) {
                chartOptions['annotations'] = {
                    xaxis: [
                        {
                            x: today,
                            borderColor: 'transparent',
                            label: {
                                borderColor: 'transparent',
                                style: {
                                    color: 'rgba(255, 0, 0, 1)',
                                    background: 'transparent',
                                    fontSize: '40px',
                                    fontWeight: 'bold',
                                    cssClass: 'today-triangle-marker',
                                    padding: {
                                        left: 0,
                                        right: 0,
                                        top: 0,
                                        bottom: 0,
                                    }
                                },
                                text: '▲',
                                position: 'bottom',
                                orientation: 'horizontal',
                                offsetY: 8,
                                offsetX: 0,
                            }
                        }
                    ]
                };
            }

            chart['title'] = element.Cam;
            chart['colors'] = "primary";
            chart['value'] = element.Cam;
            chart['series'] = [{ name: "files", data: dataWithDate.data }];
            chart['options'] = chartOptions;
            chart['speed'] = element.speed;

            // Maintain live data values if available in Redux store
            if (storeLiveData) {
                let liveData = storeLiveData?.data?.filter(item => item.live.bus === element.Cam);
                if (liveData?.length > 0) {
                    chart.snr = liveData[0]?.live?.SNR;
                    chart.tx_rate = liveData[0]?.live?.tx_rate;
                    chart.s_strength = liveData[0]?.live?.S_strength;
                    chart.speed = liveData[0]?.live?.["Dnld_Speed mbps"] || element.speed;
                } else {
                    chart.snr = "";
                    chart.tx_rate = "";
                    chart.s_strength = "";
                }
            }

            data.push(chart);
        }
        return data;
    }

    useEffect(() => {
        let data = getChartDataForAll(details, recordingOptions, liveCameraData);
        setChartData(data);
        console.log("Recording Chart Data", data);
    }, [details, liveCameraData])

    const handleForceRecording = () => {
        if (macAddress) {
            let queryParam = {
                "sid": sid,
                "date": startDate,
                "camid": macAddress,
                "rid": 7,
                "enddate": endDate,
                "payload": "",
            }
            dispatch(getTableData(queryParam))
        }
        else {
            console.log("No mac Address");
        }
    }


    const [isFetching, setIsFetching] = useState(false);
    const handleOnClickFetchLive = () => {
        console.log(); setSpeed(true);
        if (macAddress) {
            let queryParams = {
                sid: sid,
                mac: macAddress,
            }
            dispatch(getLiveCameraData(queryParams, (response) => {
                if (response?.OK) {
                    response?.OK?.data?.map((item) => {
                        chartsData.map((chart) => {
                            if (item.live.bus === chart.title) {
                                chart.speed = item.live?.["Dnld_Speed mbps"];
                            }
                        })
                    });
                }
            }));
        }
        setIsFetching(true);
        setTimeout(() => {
            setIsFetching(false);
        }, 10000);

    }

    // Removed redundant useEffect that was mutating chartsData directly



    return (
        <React.Fragment>
            {" "}
            <Card className='cam_and_route' >
                <CardBody className='pt-2 pb-2'>
                    {/* Route Details Section */}
                    <CardTitle className="mb-3">
                        <Row>
                            <Col className='align-self-center' style={{ textAlign: 'left' }} >
                                <h3>Bus/Route Details {details?.RouteDetail?.Route}</h3>
                            </Col>
                        </Row>
                    </CardTitle>
                    <Row>
                        <Col sm="6" className=''>
                            <h4> Live Status & Recording Status</h4>
                        </Col>

                        <Col sm={4} md={3} className="d-flex justify-content-center justify-content-sm-start" id="Force_Recording">
                            <button className={`btn btn ${liveStatus && role.includes(36) ? 'btn-primary' : 'btn-secondary'} btn-sm p-2`} disabled={!liveStatus || !role.includes(36)} onClick={handleForceRecording}>Force Recording</button>
                            {!liveStatus && <Tooltip
                                isOpen={tooltipOpen}
                                placement="bottom"
                                target="Force_Recording"
                                toggle={() => { setTooltipOpen(!tooltipOpen) }}>
                                No Live Camera
                            </Tooltip>
                            }
                        </Col>

                        <Col sm={2} md={3} className="d-flex justify-content-center justify-content-sm-start" id="fetch_live">
                            <button className={`btn btn ${!isFetching ? 'btn-primary' : 'btn-secondary'} btn-sm p-2`} disabled={isFetching} onClick={handleOnClickFetchLive}>Fetch Live</button>
                        </Col>


                    </Row>

                    <Row>

                        <Col sm="6">
                            <Row>
                                <h6>Owner : <span style={{ textWrap: "nowrap" }}>{details?.RouteDetail.Own}</span></h6>
                                <h6>InCharge : <span style={{ textWrap: "nowrap" }}>{details?.RouteDetail.Incharge}</span></h6>
                                <h6>InCharge Mobile No:<span style={{ textWrap: "nowrap" }}> {details?.RouteDetail.In_mob}  </span></h6>
                                <h6>Driver Name: <span style={{ textWrap: "nowrap" }}>{details?.RouteDetail.Driver}</span> </h6>
                                <h6>Driver Mobile No: <span style={{ textWrap: "nowrap" }}> {details?.RouteDetail.DrMobile} </span></h6>
                                <Row>
                                    <Col><a className='link' onClick={showDetail} >Bus Details</a></Col>
                                </Row>
                            </Row>
                        </Col>
                    </Row>

                    <br />

                    {
                        cameraList && cameraList.map((item) => {
                            const report = (chartsData || []).find(r => r.value === item.Cam);
                            const snrBarOptions = buildSnrBarOptions(report?.s_strength);
                            return (
                                <Row key={item.Cam}>

                                    <Col md={2} className='text-center'>
                                        <div className='d-flex justify-content-center'>
                                            <i className={`mdi ${item.broken === 1 ? 'mdi-video-off' : 'mdi-video'} ${item.flicker ? 'bx-burst' : ''} px-1 font-size-18`} style={{ color: setColor(item.Status) }} />
                                            <span className="pt-1"> {item.Cam}</span>
                                        </div>
                                    </Col>
                                    {report ? (
                                        <Col md={6} className='text-center'>
                                            <Row>
                                                <Col xs={12} >
                                                    <ReactApexChart
                                                        options={report.options}
                                                        series={report.series}
                                                        type="area"
                                                        height={70}
                                                        className="apex-charts"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col className='text-center pt-3'>
                                                    <span>Speed: {report.speed}</span>
                                                </Col>
                                            </Row>

                                        </Col>
                                    ) : (
                                        <Col md={5} className="text-muted text-center">No Chart Data</Col>
                                    )}



                                    <Col md={4} >
                                        <span>IP Address:  {item.ip}</span>
                                        <br />
                                        <span>MAC: {item.mac}</span>
                                        <br />
                                        <span className='pb-0 mb-0'>SNR : {report?.snr ? report.snr : "N/A"}</span>
                                        <br />
                                        <span className='pb-0 pt-0 mb-0'  >Tx Rate: {report?.tx_rate ? report.tx_rate : "N/A"}</span>
                                        <br />
                                        <span className='pb-0 pt-0 mb-0'>Signal Strenght : {report?.s_strength ? report.s_strength : "N/A"}</span>
                                        <br />
                                        <span>Last Seen Online: {moment(item.AccessDate).format("YYYY-MM-DD")}</span>
                                        <br />
                                        <span>Files Seen in Camera: {moment(item.PlDate).format("YYYY-MM-DD")}</span>
                                        <br />
                                        <span>Files Downloaded: {moment(item.RecDate).format("YYYY-MM-DD")}</span>
                                        <Row className='p-0 m-0'>
                                            <ReactApexChart options={snrBarOptions} series={snrBarSeries} type="bar" height="80" width="180" />
                                        </Row>
                                    </Col>
                                </Row>
                            );

                        }
                        )}
                </CardBody>
            </Card>

            {/* Modals */}
            <Modal isOpen={modal} className='modal-lg' role="dialog" autoFocus={true} centered data-toggle="modal"
                toggle={() => { setModal(!modal); }} >
                <img src={img_src} onError={(e) => { resetImage(e) }} />
            </Modal>
            <Modal isOpen={isLiveStreamOpen} style={{ maxWidth: "730px" }} toggle={() => { setIsLiveStreamOpen(!isLiveStreamOpen) }} >
                <ModalHeader toggle={() => { setIsLiveStreamOpen(!isLiveStreamOpen) }}>Live Stream</ModalHeader>
                <Rtsp rtsp={rtsp} />
            </Modal>
            <Modal isOpen={isshowDetailOpen} style={{ maxWidth: "650px" }} toggle={() => { setIsShowDetailOpen(!isshowDetailOpen) }}>
                <ModalHeader toggle={() => { setIsShowDetailOpen(!isshowDetailOpen) }}>
                    <Row>
                        <Col>Bus/Route Details</Col>
                    </Row>
                </ModalHeader>
                <Bus_Detail_Form Route={route} NewBus={false} AddCam={false} Bus_Nameplate={Bus_Nameplate} />
            </Modal>
            <Modal isOpen={isshowCamDetailOpen} style={{ maxWidth: "650px" }} toggle={() => { setIsShowCamDetailOpen(!isshowCamDetailOpen) }}>
                <ModalHeader toggle={() => { setIsShowCamDetailOpen(!isshowCamDetailOpen) }}>Cam Details</ModalHeader>
                <Cam_Detail_Form camDetail={caminfo} />
            </Modal>
        </React.Fragment>
    )
}

export default CombinedDetailsCard
